import { PatientRecovery } from "../../PatientDetails/containers/components/PatientRecovery/PatientRecovery";
export const CreateTemplate = () => {
  return (
    <div
      id="create-template"
      className="container max-w-[90%] m-auto px-8 pt-[50px] pb-[100px]"
    >
      <PatientRecovery isTemplate />
    </div>
  );
};
